import { TranslationKeys } from '~frontend-common/i18n/english/driver-licence-details.i18n';

const keys: TranslationKeys = {
  driverLicenceDetails: {
    yearHelper_self: 'Vous avez eu votre permis en {{fromYear}}-{{toYear}}',
    yearHelper_other: '{{firstName}} a eu son permis en {{fromYear}}-{{toYear}}',
    agePlaceholder: 'Ex. 18',
    firstLicence: {
      fieldLabel: 'Quelle était la classe du permis ?',
      helper:
        'Vous n’êtes pas certain? La plupart des gens commencent avec un permis G1 (permis d’apprenti avec plusieurs restrictions), puis passent au G2, et finalement au permis complet G.\nSi vous deviez conduire avec un accompagnateur ou éviter les autoroutes, c’était probablement votre G1.',
    },
    g2Licence: {
      fieldLabel_self: 'Avez-vous obtenu votre permis de classe G2 ?',
      fieldLabel_other: 'Cette personne a-t-elle obtenu un permis de classe G2 ?',
      helper:
        'Le G2 vient après le G1. Il permet de conduire seul, mais avec certaines restrictions comme des limites de passagers ou des règles la nuit, surtout si vous aviez moins de 20 ans.',
      ageLabel_self: 'Quel âge aviez-vous lorsque vous avez obtenu votre permis de classe G2 ?',
      ageLabel_other: 'Quel âge avait cette personne lorsqu’elle a obtenu son permis de classe G2 ?',
      ageHelper: 'En général, les gens obtiennent leur G2 environ 8 à 12 mois après le G1.',
    },
    gLicence: {
      fieldLabel_self: 'Avez-vous obtenu votre permis de classe G ?',
      fieldLabel_other: 'Cette personne a-t-elle obtenu un permis de classe G ?',
      helper: 'Le permis G est la dernière étape — il n’y a plus de restrictions, vous avez tous les privilèges.',
      ageLabel_self: 'Quel âge aviez-vous lorsque vous avez obtenu votre permis de classe G ?',
      ageLabel_other: 'Quel âge avait cette personne lorsqu’elle a obtenu son permis de classe G ?',
      ageHelper: 'Beaucoup de gens obtiennent leur G entre 1 et 5 ans après leur G2.',
    },
    driverTraining: {
      fieldLabel_self: 'Avez-vous suivi un cours de conduite ?',
      fieldLabel_other: 'Cette personne a-t-elle suivi un cours de conduite ?',
      helper: 'C’est un cours donné par une école de conduite reconnue (avec théorie en classe + pratique en voiture).',
      suggestionNo: 'Non, jamais suivi de cours de conduite',
      suggestionYes: 'Oui, en {{year}}',
    },
  },
};

export default keys;
